import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/index.vue'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login',
    alias: '登录',
    component: () => import('@/views/login.vue'),
    meta: {
      isLogin: false
    }
  },
  {
    path: '/home',
    name: 'home',
    alias: '首页',
    component: () => import('@/views/home.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/declarationInformation',
    name: 'declarationInformation',
    alias: '申报',
    component: () => import('@/views/declarationInformation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/messageList',
    name: 'messageList',
    alias: '消息列表',
    component: () => import('@/views/messageList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/messageDetails',
    name: 'messageDetails',
    alias: '消息详情',
    component: () => import('@/views/messageDetails.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/conference',
    name: 'conference',
    alias: '会刊信息',
    component: () => import('@/views/conference.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/busInformation',
    name: 'busInformation',
    alias: '会员信息',
    component: () => import('@/views/busInformation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/productList',
    name: 'productList',
    alias: '产品管理',
    component: () => import('@/views/productList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/nameTag',
    name: 'nameTag',
    alias: '胸卡管理',
    component: () => import('@/views/nameTag.vue'),
    meta: {
      isLogin: true
    }
  },
  
  {
    path: '/createProduct',
    name: 'createProduct',
    alias: '创建产品',
    component: () => import('@/views/createProduct.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/exhibitorManual',
    name: 'exhibitorManual',
    alias: '展商手册',
    component: () => import('@/views/exhibitorManual.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/shellScheme',
    name: 'shellScheme',
    alias: '展位准备标摊',
    component: () => import('@/views/shellScheme.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/standPrepare',
    name: 'standPrepare',
    alias: '展位准备',
    component: () => import('@/views/standPrepare.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invitation',
    name: 'invitation',
    alias: '制作邀请函',
    component: () => import('@/views/invitation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/diyPoster',
    name: 'diyPoster',
    alias: '自定义邀请函',
    component: () => import('@/views/diyPoster.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/attestation',
    name: 'attestation',
    alias: '展商实名认证',
    component: () => import('@/views/attestation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/eventRegistration',
    name: 'eventRegistration',
    alias: '活动报名',
    component: () => import('@/views/eventRegistration.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/contactPerson',
    name: 'contactPerson',
    alias: '联系人',
    component: () => import('@/views/contactPerson.vue'),
    meta: {
      isLogin: true
    }
  },


  
  {
    path: '/dutyNotice',
    name: 'dutyNotice',
    alias: '责任通知',
    component: () => import('@/views/dutyNotice.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/services',
    name: 'services',
    alias: '免费宣传服务',
    component: () => import('@/views/services.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/aptitude',
    name: 'aptitude',
    alias: '企业资质及发票',
    component: () => import('@/views/aptitude.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    alias: '已签订协议',
    component: () => import('@/views/agreement.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/instructions',
    name: 'instructions',
    alias: '参展须知',
    component: () => import('@/views/instructions.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/reservation',
    name: 'reservation',
    alias: '酒店预定',
    component: () => import('@/views/reservation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/businesslicense',
    name: 'businesslicense',
    alias: '营业执照',
    component: () => import('@/views/businesslicense.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/property',
    name: 'property',
    alias: '产品知识产权',
    component: () => import('@/views/property.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invoice',
    name: 'invoice',
    alias: '发票',
    component: () => import('@/views/invoice.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/introduce',
    name: 'introduce',
    alias: '宣传介绍',
    component: () => import('@/views/introduce.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/recruit',
    name: 'recruit',
    alias: '订单管理',
    component: () => import('@/views/recruit.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/PaymentManagement',
    name: 'PaymentManagement',
    alias: '缴费管理',
    component: () => import('@/views/PaymentManagement.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/paymentInfoList',
    name: 'paymentInfoList',
    alias: '付款信息',
    component: () => import('@/views/paymentInfoList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/eventNotification',
    name: 'eventNotification',
    alias: '活动通知',
    component: () => import('@/views/eventNotification.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/MessageDetail',
    name: 'MessageDetail',
    alias: '活动通知详情',
    component: () => import('@/views/MessageDetail.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/payment',
    name: 'payment',
    alias: '支付',
    component: () => import('@/views/payment.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/InvoiceManage',
    name: 'InvoiceManage',
    alias: '发票管理',
    component: () => import('@/views/InvoiceManage.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invoiceDetails',
    name: 'invoiceDetails',
    alias: '新建抬头',
    component: () => import('@/views/invoiceDetails.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/orderSee',
    name: 'orderSee',
    alias: '订单查看',
    component: () => import('@/views/orderSee.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/memberCert',
    name: 'memberCert',
    alias: '会员证书',
    component: () => import('@/views/memberCert.vue'),
    meta: {
      isLogin: true
    }
  },

  // 票务系统
  {
    path: '/ticketList',
    name: 'ticketList',
    alias: '电子票列表',
    component: () => import('@/views/ticketing/ticketList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/activityList',
    name: 'activityList',
    alias: '活动列表',
    component: () => import('@/views/ticketing/activityList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/activityDetail',
    name: 'activityDetail',
    alias: '查看活动',
    component: () => import('@/views/ticketing/activityDetail.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/activityReview',
    name: 'activityReview',
    alias: '活动审核',
    component: () => import('@/views/ticketing/activityReview.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/invitationList',
    name: 'invitationList',
    alias: '邀请函',
    component: () => import('@/views/ticketing/invitationList.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/newInvitation',
    name: 'newInvitation',
    alias: '新建邀请函',
    component: () => import('@/views/ticketing/newInvitation.vue'),
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/downloadInvitation',
    name: 'downloadInvitation',
    alias: '下载邀请函',
    component: () => import('@/views/ticketing/downloadInvitation.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/ticketReview',
    name: 'ticketReview',
    alias: '票务审批',
    component: () => import('@/views/ticketing/ticketReview.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/otherDeclaration',
    name: 'otherDeclaration',
    alias: '其他活动申报',
    component: () => import('@/views/ticketing/otherDeclaration'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/declarationResult',
    name: 'declarationResult',
    alias: '其他活动申报结果',
    component: () => import('@/views/ticketing/declarationResult.vue'),
    meta: {
      isLogin: true
    }
  },
  {
    path: '/otherDeclarationReview',
    name: 'otherDeclarationReview',
    alias: '其他活动申报审核',
    component: () => import('@/views/ticketing/otherDeclarationReview'),
    meta: {
      isLogin: true
    }
  },
  // 新功能模块 纸质证件管理
  {
    path: '/paperCertList',
    name: 'paperCertList',
    alias: '纸质证件管理列表',
    component: () => import('@/views/paperCert/paperCertList.vue'),
    meta: {
      isLogin: true
    }
  }
]
const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
